import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	CLIENT_MOBILE_CARD_CONFIG,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * Contact Due list configuration
 * Clients needing contact follow-up, sorted by last contact date
 */
export const contactDueList: ListBuilderList = {
	id: 'contact-due-list',
	cacheTTL: 300000,
	name: 'Contact Due',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	columns: createClientColumnsNoLifecycle(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description: 'Clients needing contact follow-up, sorted by last contact date',
	defaultSortId: 'recent-contact-asc',
	requiredFields: [
		'client._id',
		'client.address1',
		'client.averageInvoiceRevenue',
		'client.businessType',
		'client.city',
		'client.companyNames',
		'client.email',
		'client.externalId',
		'client.externalId2',
		'client.fax',
		'client.forecastedReorderDate',
		'client.googlePlaceId',
		'client.lastContactDate',
		'client.latitude',
		'client.leadOrCustomer',
		'client.longitude',
		'client.name',
		'client.nextActivityDate',
		'client.phone',
		'client.salesStatus',
		'client.state',
		'client.zip',
	],
	activeFilters: ACTIVITY_LIST_ACTIVE_FILTERS,
	sortOrder: 3,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		specialFilters: {
			defaultValue: [
				{
					id: 'contact_due',
					label: 'Contact Due',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
